<div class="main-container">
  <p>
    {{ 'waygate.technicalErrorsInConfig' | cxTranslate }} <br />
    <span (click)="openModal()">
      {{ 'waygate.customerSupport' | cxTranslate }} </span
    >.
  </p>
</div>
